import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export default (build: EndpointBuilder<any, any, any>) =>
  build.mutation<Response, Body>({
    query: (body) => ({
      url: `v4/pitch-owner/tournaments/${body.tournamentId}/matches/${body.matchId}/list-target-seed-teams`,
      method: 'GET',
    }),
  });

interface Body {
  tournamentId: number;
  matchId: number;
}

interface Response {
  data: {
    teams: {
      id: number;
      name: string;
    }[];
  };
}
